import VideoCard from "./VideoCard";
import { Link } from "react-router-dom";
import AdVideo from "./AdVideo";
import { useSelector } from "react-redux";
import Shimmer from "./Shimmer";
import useVideoList from "../utils/useVideoList";

const VideoContainer = () => {
  const isMenuOpen = useSelector((store) => store.app.isMenuOpen);
  const videoList = useVideoList();

  if (!videoList || videoList.length === 0) {
    return <Shimmer />;
  }

  return (
    <div
      className={`overflow-hidden w-full mt-14 grid grid-flow-row ${
        isMenuOpen ? "grid-cols-3" : "grid-cols-4"
      }`}
    >
      <AdVideo />
      {videoList.map((video) => {
        const videoUrlId = video?.id?.videoId || video?.id;

        return (
          <Link key={videoUrlId} to={`/watch?v=${videoUrlId}`}>
            <VideoCard info={video} />
          </Link>
        );
      })}
    </div>
  );
};

export default VideoContainer;
